import axios from '@axios'
import store from '@/store'

export function ServiceRecords() {
  this.recordsAll = query => new Promise((resolve, reject) => {
    axios.get('records/all', { params: query })
      .then(resp => {
        resolve(resp.data)
      })
      .catch(err => {
        console.error('Erro ao buscar todos os registros:', err)
        reject(err)
      })
  })

  this.recordById = id => new Promise((resolve, reject) => {
    store.commit('record/setLoading', true)
    axios.get(`records/byid/${id}`)
      .then(resp => {
        resolve(resp.data)
      })
      .catch(err => {
        console.error(`Erro ao buscar registro por ID (${id}):`, err)
        reject(err)
      })
      .finally(() => {
        store.commit('record/setLoading', false)
      })
  })

  this.recordCreate = data => new Promise((resolve, reject) => {
    axios.post('records/create', data)
      .then(resp => {
        resolve(resp.data)
      })
      .catch(err => {
        console.error('Erro ao criar registro:', err)
        reject(err)
      })
  })

  this.recordUpdate = (id, data) => new Promise((resolve, reject) => {
    axios.put(`records/update/${id}`, data)
      .then(resp => {
        resolve(resp.data)
      })
      .catch(err => {
        console.error('Erro ao atualizar registro:', err)
        reject(err)
      })
  })

  this.fetchMedicines = params => new Promise((resolve, reject) => {
    axios.get('bulario/pesquisar', { params })
      .then(resp => {
        resolve(resp.data)
      })
      .catch(err => {
        console.error('Erro ao buscar bulário:', err)
        reject(err)
      })
  })

  this.fetchHistoryPatient = (id, query) => new Promise((resolve, reject) => {
    axios.get(`records/history/${id}`, { params: query })
      .then(resp => {
        resolve(resp.data)
      })
      .catch(err => {
        console.error('Erro ao buscar histórico do paciente:', err)
        reject(err)
      })
  })
}
